import { createSlice } from "@reduxjs/toolkit";
import {
  Group,
  EditPopSettings,
  Question,
  Section
} from "./questionPaperUtils";

export const SectionListSlice = createSlice({
  name: "SectionListSlice",
  initialState: {
    data: {} as any,
    question: {} as Question,
    isPreview: false,
    formData: {} as any,
    isRearranging: false,
    sectionOrderList: [],
    selectedSection: {} as Section,
    selectedGroup: {} as Group,
    editPopSettings: {
      showQuestionLimit: false,
      showRandomization: false,
      isUpdated: false
    } as EditPopSettings,
    selectedQuestion: {} as Question,
    hasCodingGroups: false,
    sectionGroupsExpanded: {} as Record<string, boolean | null>
  },
  reducers: {
    setQuestion(state, action) {
      state.question = action.payload;
    },
    setData(state, action) {
      state.data = action.payload;
    },
    updateSectionList(state, action) {
      state.data.sectionList = action.payload;
    },
    setForm(state, action) {
      state.formData = action.payload;
    },
    setIsRearranging(state) {
      state.isRearranging = true;
    },
    resetIsRearranging(state) {
      state.isRearranging = false;
    },
    setSectionOrderList(state, action) {
      state.sectionOrderList = action.payload;
    },
    setSelectedSection(state, action) {
      state.selectedSection = action.payload;
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroup = {
        ...state.selectedGroup,
        ...action.payload
      };
    },
    updateSettings(state, action) {
      state.editPopSettings = {
        ...state.editPopSettings,
        ...action.payload
      };
    },
    setSelectedQuestion(state, action) {
      state.selectedQuestion = action.payload;
    },
    setIsPreviewFullscreen(state, action) {
      state.isPreview = action.payload;
    },
    setHasCodingGroups(state, action) {
      state.hasCodingGroups = action.payload;
    },
    setSectionGroupsExpanded(state, action) {
      if (!state.sectionGroupsExpanded) {
        state.sectionGroupsExpanded = {};
      }
      state.sectionGroupsExpanded[action.payload.sectionId] =
        action.payload.expanded;
    }
  }
});

export default SectionListSlice;
export const SectionListActions = SectionListSlice.actions;
